export default "/static/build/about-us-hero-mobile.webp";